import { render, staticRenderFns } from "./H5Footer.vue?vue&type=template&id=f63f67a8&scoped=true&"
import script from "./H5Footer.vue?vue&type=script&lang=js&"
export * from "./H5Footer.vue?vue&type=script&lang=js&"
import style0 from "./H5Footer.vue?vue&type=style&index=0&id=f63f67a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63f67a8",
  null
  
)

export default component.exports